<template>
  <div class="item-box-430">
    <!-- 头部搜索框 start  -->
    <!-- <SearchBlock
      :smart-class-search="true"
      :smart-dis-abled="smartDisAbled"
      @getSearchValue="handleGetSearchValue"
    ></SearchBlock> -->
    <!-- <div @click="changeStep">点击切换</div> -->
    <!-- 头部搜索框 end  -->
    <!-- 分班步骤 start  -->
    <DivideClassStep
      :step="step"
      :school-id="schoolId"
      :branch-id="branchId"
      :term-code="termCode"
      :year-code="yearCode"
      :random="random"
      @divided="successDivide"
    ></DivideClassStep>
    <div :class="step!==-1?'divide-class-content':''">
      <keep-alive :include="keepAliveKey">
        <component
          :is="isComponent"
          :tab-type="tabType"
          :product-ids="productIds"
          :preview-params="previewParams"
          :school-name="schoolName"
          :school-id="schoolId"
          :branch-id="branchId"
          :term-code="termCode"
          :year-code="yearCode"
          :start-time="startTime"
          :week-cycle-num="weekCycleNum"
          :random="random"
          @on-finish="onFinish"
          @search="handleGetSearchValue"
        ></component>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import BeforeDivideClass from './assets/components/BeforeDivideClass.vue';
import SmartClassStepTwo from './assets/components/SmartClassStepTwo.vue';
import DivideClassStep from './assets/components/DivideClassStep.vue';
import SearchBlock from '../assets/components/SearchBlock.vue';
import SmartDivideSelectSchool from './assets/components/SmartDivideSelectSchool';
export default {
  components: {
    SearchBlock,
    DivideClassStep,
    BeforeDivideClass,
    SmartClassStepTwo,
    SmartDivideSelectSchool
  },
  data() {
    return {
      step: -1,
      searchData: null,
      schoolId: '', // 学校id
      branchId: '', // 校区id
      termId: '', // 学期id
      productId: '', // 选中的课程商品的id
      previewParams: {}, // 分班预览需要获取的参数
      startTime: '', // 开课日期
      weekCycleNum: 1, // 周循环数
      random: 0,
      tabType: -1, // 步骤一选中哪个tab
      keepAliveStep: false,
      productIds: {}, // 多选 课程分班确认信息
      termCode: '',
      yearCode: 0,
      schoolName: ''
    };
  },
  computed: {
    isComponent() {
      // 1: 渲染分班确认组件，2: 渲染确定成班组件
      return this.step === 1 ? 'BeforeDivideClass' : this.step === 2 ? 'SmartClassStepTwo' : 'SmartDivideSelectSchool';
    },
    smartDisAbled() {
      return this.step === 2;
    },
    keepAliveKey() {
      return this.keepAliveStep ? 'BeforeDivideClass' : '';
    }
  },
  mounted() {
    this.$eventHub.$on('backStep', data => {
      this.backStep(data);
    });
  },
  destroyed() {
    this.$eventHub.$off('backStep');
  },
  methods: {
    handleGetSearchValue(e) {
      this.searchData = e;
      this.schoolId = e.schoolId;
      this.branchId = e.branchId;
      this.termCode = e.termCode;
      this.yearCode = e.yearCode;
      this.schoolName = e.schoolName;
      this.random = new Date().valueOf();
      this.step = 1;
      console.log('拿到的搜索值-======', e, this.schoolId);
    },
    changeStep() {
      this.previewParams = {
        productId: this.productId,
        smartPartitionType: 1, // 分班模式：1按照人数 2按照行政班
        limitOfStuNum: 2 // 分班人数
      };
      this.step = 2;
    },
    onFinish(e) {
      switch (e.step) {
        case 1:
          const {
            productIds,
            smartPartitionType,
            tabType
          } = e.data;

          this.previewParams = {
            smartPartitionType
          };
          this.productIds = productIds;
          // this.startTime = startTime;
          // this.weekCycleNum = weekCycleNum;
          this.tabType = tabType;
          this.keepAliveStep = true;
          this.step = 2;
          console.log(this.productIds, 'productIds');
          break;
      }
    },
    successDivide() {
      this.$eventHub.$emit('refreshWaitPartition');
    },
    backStep(e) {
      console.log('backStep');

      if (e.type === 'cancel') {
        const { previewParams, startTime, weekCycleNum, tabType } = e.data;
        this.previewParams = previewParams;
        this.startTime = startTime;
        this.weekCycleNum = weekCycleNum;
        this.tabType = tabType;
        this.keepAliveStep = true;
      } else if (e.type === 'refresh') {
        this.keepAliveStep = true;
        this.$eventHub.$emit('refreshWaitPartition');
        // this.divideSuccess++;
      } else {
        this.keepAliveStep = false;
      }
      this.$nextTick(() => {
        this.step = 1;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.item-box-430 {
  padding: 30px;
}
.divide-class-content {
  max-height: calc(100vh - 370px);
  overflow-y: auto;
}
</style>
